import { IProjectDataSQP } from "../../types/projectDataSQP.types"

export enum ProjectActionType {
  FETCH_PROJECT_DATA_SQP = "FETCH_PROJECT_DATA_SQP",
  FETCH_PROJECT_DATA_SQP_SUCCESS = "FETCH_PROJECT_DATA_SQP_SUCCESS",
  FETCH_PROJECT_DATA_SQP_ERROR = "FETCH_PROJECT_DATA_SQP_ERROR",

  FETCH_PROJECT_DATA_SQP_BY_LAST_WEEK = "FETCH_PROJECT_DATA_SQP_BY_LAST_WEEK",
  FETCH_PROJECT_DATA_SQP_SUCCESS_BY_LAST_WEEK = "FETCH_PROJECT_DATA_SQP_SUCCESS_BY_LAST_WEEK",
  FETCH_PROJECT_DATA_SQP_ERROR_BY_LAST_WEEK = "FETCH_PROJECT_DATA_SQP_ERROR_BY_LAST_WEEK",
}

interface FetchProjects {
  type: ProjectActionType.FETCH_PROJECT_DATA_SQP
}

interface FetchProjectsSuccess {
  type: ProjectActionType.FETCH_PROJECT_DATA_SQP_SUCCESS
  payload: Record<string, IProjectDataSQP[]>
}

interface FetchProjectsError {
  type: ProjectActionType.FETCH_PROJECT_DATA_SQP_ERROR
  payload: string
}

interface FetchProjectsByLastWeek {
  type: ProjectActionType.FETCH_PROJECT_DATA_SQP_BY_LAST_WEEK
}

interface FetchProjectsSuccessByLastWeek {
  type: ProjectActionType.FETCH_PROJECT_DATA_SQP_SUCCESS_BY_LAST_WEEK
  payload: Record<string, IProjectDataSQP[]>
}

interface FetchProjectsErrorByLastWeek {
  type: ProjectActionType.FETCH_PROJECT_DATA_SQP_ERROR_BY_LAST_WEEK
  payload: string
}

export type ProjectAction = FetchProjects | FetchProjectsSuccess | FetchProjectsError

export type ProjectByLastWeekAction =
  | FetchProjectsByLastWeek
  | FetchProjectsSuccessByLastWeek
  | FetchProjectsErrorByLastWeek

export interface IProjectState {
  projectDataSQP: Record<string, IProjectDataSQP[]>
  loading: boolean
  error: string | null
}

export interface IProjectByLastWeekState {
  projectDataSQPByLastWeek: Record<string, IProjectDataSQP[]>
  loading: boolean
  error: string | null
}
